<template>
  <div class="container">
    <div
      id="page1-div"
      ref="document"
      class="container interline border page-container"
    >
      <div class="col-12 text-justify p-5">
        <div class="row ">
          <div class="col-3  text-center  pt-2">
            <img src="../Logo-GPI.png" class="rounded" width="100px" />
          </div>
          <div class="col-6 text-center pt-2">
            <span class="ft11Black">
              ORDEN DE INSTALACION DE GPS
              <br />
              <br />
            </span>
          </div>
        </div>

        <div class="col-7"></div>
        <div class="col-12 m-4">
          <span class="ft11">
            <br /><br />
            VENDEDOR:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.nombre_asesor }}
            </span>
          </span>
          <br /><br />
          <span class="ft11">
            NOMBRE DEL CLIENTE:<span v-bind:class="{ marca: data.showMarca }">
              {{ data.nombre_cliente }}</span
            >
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;No. OPERACIÓN:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.No_Operacion_Cliente }}</span
            >
            <br /><br />
          </span>
          <span class="ft11">
            PLAZO DE CREDITO:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.plazo }}</span
            >
            <br /><br />
          </span>

          <div class="row pt-lg-3">
            <div class="col-3 text-center"></div>
            <div class="col-1  text-center"></div>
            <span class="ft11Black">
              CARACTERISTICAS DEL VEHICULO
            </span>
          </div>
          <div class="col-11 row pt-lg-3">
            <div class="col-4 text-center">
              <span class="ft11">
                MARCA
              </span>
            </div>
            <div class="col-4  text-center">
              <span class="ft11">
                VERSION
              </span>
            </div>
            <div class="col-4  text-center">
              <span class="ft11">
                MODELO
              </span>
            </div>
          </div>
          <div class="col-11 row pt-lg-2">
            <div class="col-4 border border-dark text-center">
              <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                {{ data.marca_vehiculo }}
              </span>
            </div>
            <div class="col-4 border border-dark text-center">
              <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                {{ data.año_vehiculo }}
              </span>
            </div>
            <div class="col-4 border border-dark text-center">
              <span class="ft11">
                <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                  {{ data.modelo_vehiculo }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-11 row pt-lg-3">
            <div class="col-4 text-center"><span class="ft11"> </span></div>
            <div class="col-2  text-center">
              <span class="ft11">
                No. MOTOR
              </span>
            </div>
            <div class="col-4  text-center">
              <span class="ft11">
                No. SERIE
              </span>
            </div>
          </div>
          <div class="col-11 row pt-lg-2">
            <div class="col-2  text-center"><span class="ft11"> </span></div>
            <div class="col-4 border border-dark text-center">
              <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                {{ data.numero_motor_vehiculo.toUpperCase() }}
              </span>
            </div>
            <div class="col-4 border border-dark text-center">
              <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                {{ data.numero_serie_vehiculo.toUpperCase() }}
              </span>
            </div>
          </div>
          <div class="row pt-lg-3">
            <div class="col-1 text-center"></div>
            <div class="col-1  text-center"></div>
            <span class="ft11Black">
              PARA LLENADO DE PROCESO DE FORMALIZACION POR AREA DE GPS
            </span>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-2 text-right">
              <span class="ft11">
                No. EQUIPO
              </span>
            </div>
            <div class="col-3 border-bottom border-dark"></div>
            <div class="col-4 text-right">
              <span class="ft11">
                No. LLENA CELULAR GPS
              </span>
            </div>
            <div class="col-2 border-bottom border-dark"></div>
          </div>
          <div class="row pt-lg-4">
            <div class="col-3 text-center"></div>
            <div class="col-1  text-center"></div>
            <span class="ft11Black">
              OBSERVACIONES TECNICAS
            </span>
          </div>
          <div class="col-12 row pt-lg-3">
            <div class="col-4 text-center">
              <span class="ft10">
                OBSERVACIONES DEL VEHICULO
              </span>
            </div>
            <div class="col-2  text-center">
              <span class="ft10">
                CHECKENGINE
              </span>
            </div>
            <div class="col-3  text-center">
              <span class="ft10">
                BATERIA
              </span>
            </div>
            <div class="col-3  text-center">
              <span class="ft10">
                DETALLES FISICOS
              </span>
            </div>
          </div>
          <div class="col-12 row pt-lg-1">
            <div class="col-4 text-center"><span class="ft11"> </span></div>
            <div class="col-2 border border-dark text-center">
              <span class="ft11">
                SI&emsp;&emsp; NO
              </span>
            </div>
            <div class="col-3 border border-dark text-center">
              <span class="ft11">
                SI&emsp;&emsp;&emsp;&emsp; NO
              </span>
            </div>
            <div class="col-3 border border-dark text-center">
              <span class="ft11">
                SI&emsp;&emsp;&emsp;&emsp; NO
              </span>
            </div>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-3 text-right">
              <span class="ft11">
                OTROS Y CUALES
              </span>
            </div>

            <div class="col-9 border-bottom border-dark"></div>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-3 text-right">
              <span class="ft11">
                FECHA Y HORA DE ENTRADA
              </span>
            </div>

            <div class="col-3 border border-dark"></div>
            <div class="col-3 text-right">
              <span class="ft11">
                FECHA Y HORA DE SALIDA
              </span>
            </div>

            <div class="col-3 border border-dark"></div>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-5 text-right">
              <span class="ft11">
                UBICACIÓN DEL EQUIPO GPS EN UNIDAD
              </span>
            </div>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-3 text-right"></div>

            <div class="col-12 border border-dark"></div>
          </div>
          <div class="col-12 row pt-lg-3">
            <div class="col-6  text-center">
              <span class="ft11">
                TECNICO INSTALADOR RESPONSABLE
              </span>
            </div>
            <div class="col-6  text-center">
              <span class="ft11">
                VENDEDOR EN LA AGENCIA Y/O LOTE
              </span>
            </div>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-5  border-top border-dark text-center">
              <span class="ft11">
                NOMBRE Y FIRMA
              </span>
            </div>
            <div class="col-2  text-center"></div>
            <div class="col-5  border-top border-dark text-center">
              <span class="ft11">
                NOMBRE Y FIRMA
              </span>
            </div>
          </div>
          <div class="col-12 row pt-4">
            <div class="col-12  border border-dark text-justify">
              <span class="ft10">
                En caso de GPS instalado en comodato, éste deberá de ser
                devuelto al término de la vigencia del contrato y/o una vez
                liquidado el crédito, por lo que en caso de no devolver el mismo
                reconozco que deberé de pagar incondicionalmente a la empresa
                GPI AUTO COMERCIAL SAPI DE C.V. la cantidad de $3,500.00 por
                concepto de pago total de dicho aparato, a más tardar el
                día________, en esta plaza o en cualquier otra que se me
                requiera; Autorizando a dicha empresa para que realice el cobro
                del valor aparato como lo estime necesario. <br />
              </span>
              <span class="ft11">
                Nombre:
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }}
                </span>
                <br />
              </span>
              <span class="ft11">
                Dirección:
                <span v-bind:class="{ marca: data.showMarca }">
                  CALLE {{ data.calle_cliente }} NO.
                  {{ data.numero_calle_cliente }}
                  {{ data.colonia_cliente }}, CODIGO POSTAL
                  {{ data.codigo_postal_cliente }}, DE LA POBLACION DE
                  {{ data.colonia_cliente }}, MUNICIPIO DE
                  {{ data.municipio_cliente }},
                  {{ data.estado_cliente }}.
                </span>
                <br />
              </span>
              <span class="ft11">
                Teléfono:
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.telefono }}
                </span>
                <br />
              </span>
              <div class="col-12 row pt-4">
                <div class="col-2 text-right">
                  <span class="ft11">
                    Firma:
                  </span>
                </div>
                <div class="col-3 border-bottom border-dark"></div>
              </div>
              <span class="ft11"> <br /><br /> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutYou",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/ContratosEmpleado/Caratura1/FormatoGps.vue